// PasswordError
import React, { useEffect } from 'react';

const PasswordError = ({
    password,
    passwordCheck,
    passwordMatch,
    setPasswordMatch
}) => {
    useEffect(() => {
        setPasswordMatch(password === passwordCheck);
    }, [password, passwordCheck, setPasswordMatch]);

    if (password === "" || passwordCheck === "") {
        return null;
    }

    return (
        <div className={`passwordError ${passwordMatch ? "passwordError--success" : "passwordError--error"}`}>
            {passwordMatch ? "Пароли совпали" : "Пароли должны совпадать"}
        </div>
    );
};

export default PasswordError;